import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { Floor, FloorItem, Waiter } from '../../reservations/models/Reservation';
import { RestaurantDetails } from '../../restaurants/models/List.Restaurant';
import { AssignServerComponent } from './assign-server/assign-server.component';
import { AssignWaiterTypeEnum, AutoAssignTypeEnum, WaiterAssignment } from './models/AssignmentModel';
import { ServersAssignmentService } from './services/servers-assignment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RestaurantService } from '../../restaurants/services/Restaurant.service';

@Component({
  selector: 'app-servers-assignment',
  templateUrl: './servers-assignment.component.html'
})
export class ServersAssignmentComponent implements OnInit {
  dataLoading = true;
  isSubmitted = false;
  details: any;

  loading = false;

  restaurantId?: any;
  allRestaurants: RestaurantDetails[] = [];
  restaurantData!: any;

  floors: Floor[] = [];

  tablesToSelect = [];
  selectedTable!: FloorItem | null;
  selectedFloor!: Floor;
  serversList: Waiter[] = [];

  assignType!: AssignWaiterTypeEnum;
  ruleCtr = new FormControl(null);
  AutoAssignType = [
    AutoAssignTypeEnum.LowestReservations,
    AutoAssignTypeEnum.LastSeatedTime,
    AutoAssignTypeEnum.LowestPartySize
  ]

  constructor(
    private service: ServersAssignmentService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private router: Router,
    private restaurantService: RestaurantService
  ) { }

  ngOnInit(): void {
  }

  GetScreenData() {
    this.ResGetWaiterAssignConfig();
    this.ResGetWaiter();
    this.GetRestaurantShortDetails(this.restaurantId);
  }

  GetRestaurantShortDetails(restaurantId: any) {
    this.restaurantService.GetRestaurantShortDetails(restaurantId).subscribe((data: any) => {
      this.restaurantData = data
    })
  }

  ResGetWaiterAssignConfig() {
    this.dataLoading = true;
    this.service.ResGetWaiterAssignConfig(this.restaurantId).subscribe(
      (data: any) => {
        this.dataLoading = false;
        this.details = data;
        this.floors = data.floors as [];
        this.assignType = data.optionType || AssignWaiterTypeEnum.Auto;
        this.ruleCtr.setValue(data.autoOptionType || AutoAssignTypeEnum.LowestReservations);
        this.ruleCtr.markAsUntouched();
      }, err => {
        console.error(err);
      });
  }

  ResGetWaiter() {
    this.dataLoading = true;
    this.service.ResTableAssignWaiters(this.restaurantId).subscribe(
      (data: any) => {
        this.dataLoading = false;
        this.serversList = data;
      }, err => {
        console.error(err);
      });
  }

  save() {
    this.isSubmitted = true;
    this.ruleCtr.markAsTouched();
    if (!this.floors?.length && this.assignType == AssignWaiterTypeEnum.Manually) { return }
    if (this.ruleCtr.valid) {
      this.loading = true;
      let data: WaiterAssignment = {
        optionType: this.assignType,
        autoOptionType: this.ruleCtr.value,
        restaurantId: this.restaurantId,
        floors: this.assignType == AssignWaiterTypeEnum.Manually ? this.floors : []
      }

      this.service.ResSaveWaiterAssignConfig(data).subscribe((response: any) => {
        this.loading = false;
        if (response?.success) {
          Swal.fire({
            title: this.translate.instant('swalMsg.Success'),
            text: this.translate.instant('swalMsg.savedsuccessfully'),
            icon: 'success',
            confirmButtonText: this.translate.instant('swalMsg.Ok')
          });
          // this.ResGetWaiterAssignConfig();
          if (this.restaurantId) {
            this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
          } else {
            this.ResGetWaiterAssignConfig();
          }
        }
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.errors,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }

  openForm() {
    if (!this.selectedTable) return;
    const dialogRef = this.dialog.open(AssignServerComponent, {
      width: '50rem',
      data: {
        serversList: this.serversList,
        selectedTable: this.selectedTable,
        selectedFloor: this.selectedFloor,
        restaurantId: this.restaurantId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.serversList = result;
      }
      // this.floors.forEach(floor => {
      //   floor.tabels.forEach(table => {
      //     table.tableWaiters.forEach(waiter => {
      //       this.selectedTable?.tableWaiters.forEach(item => {
      //         if (item.id === waiter.id) {
      //           waiter.tabelsCount = item.tabelsCount;
      //         }
      //       });
      //     });
      //   });
      // })
      this.tablesToSelect = [];
    });
  }

}
